import type { AddressBlockProps } from "./types";
import PanelContainer from "../../lib/panel/panel-container";
import PanelTranslationState from "../../lib/panel/panel-translation-state";
import { BlockPanelProps } from "../../lib/register-block";
import PanelNoSettings from "../../lib/panel/panel-no-settings";


export function AddressEmailPanelRenderer(blockProps: BlockPanelProps<AddressBlockProps>) {
  return (
    <PanelContainer blockProps={blockProps}>
      <PanelNoSettings/>
      <PanelTranslationState mode="auto" portal />
    </PanelContainer>
  );
}
